import { Router } from 'react-router-dom';
import { MenuProvider } from './contexts/MenuContext';
import { AuthProvider } from './contexts/AuthContext';
import { history } from './browserHistory';
import RouterMap from './router';

/** Keep router context available to providers and all route components. */
const AppRouter = () => (
  <Router history={history}>
    <AuthProvider>
      <MenuProvider>
        <RouterMap />
      </MenuProvider>
    </AuthProvider>
  </Router>
);

export default AppRouter;
